import styled from 'styled-components';

export const PatientRequestSC = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  padding-left: 16px;
  margin-bottom: 4px;
  border-radius: 10px;
  border: 1px solid #d7d9e2;
  background: #f5f5f7;

  button {
    cursor: pointer;
  }

  .avatar {
    width: 28px;
    height: 28px;
    margin-right: 16px;
    background: #fff;
    border-radius: 50%;
  }

  .name {
    line-height: 1.25;
    color: #181e34;
    font-weight: 600;
  }

  time {
    line-height: 1.4;
    font-size: 14px;
    color: rgba(24, 30, 52, 0.5);
    font-weight: 600;
  }

  .actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;
